import React from 'react';
import HeaderCell from './header-cell';
import styles from './region-entity-table.module.scss';

export const EntityTableHeader = ({ entity, comparing }) => {
  return (
    <tr>
      <td className={styles.tableHeaderText}>
        {comparing ? entity.name : 'Summary'}
      </td>
      {!entity.name.includes('Urban Utilities') &&
        !entity.name.includes('Unitywater') && (
          <td>
            <HeaderCell label={'capacity (ML)'} value={entity.capacity} />
          </td>
        )}
      {!entity.name.includes('Urban Utilities') &&
        !entity.name.includes('Unitywater') && (
          <td>
            <HeaderCell label={'dams'} value={entity.dams} />
          </td>
        )}
      {!entity.name.includes('Urban Utilities') &&
        !entity.name.includes('Unitywater') && (
          <td>
            <HeaderCell
              label={'storage level (%)'}
              value={[entity.storageLevelMin, entity.storageLevelMax]}
            />
          </td>
        )}
      <td>
        <HeaderCell label={'service charge'} value={entity.avgServiceCharge} />
      </td>
      <td>
        <HeaderCell
          label={'consumption charge per KL'}
          value={entity.avgConsumptionCharge}
        />
      </td>
    </tr>
  );
};



// WEBPACK FOOTER //
// ./src/components/region-entity-table/entity-table-header.js